import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('insurance-companies', storeModule.createStoreModule('insurance-companies'))
